import { selectExampleNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { importanceComponent } from '@nodeTypeConfig/helpers/editComponents/importanceComponent';
import { optionalTitleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const EXAMPLE: BuildingBlockNodeConfig = {
  nodeSelector: selectExampleNode,
  information: {
    single: 'Voorbeeld',
    plural: 'Voorbeelden',
  },

  buildingBlocks: [
    { type: NodeType.PARAGRAPH },
    {
      type: NodeType.REFERENCE_GROUP,
      showInAncestorTypes: [NodeType.VISION_TEXT],
    },
  ],
  edit: [optionalTitleComponent, importanceComponent],

  isCollapsible: false,
  onNewNodeDropped: {
    openAside: false,
  },
};

export default EXAMPLE;
